import {
  Column,
  TableapiApi,
  GeojsonApi,
} from '@datum-group/isogd-openapi/lib';
import { services } from '../../API';
import { FilterValue } from '@project/components/Module/Table/Filters/FilterInput/types';
import { OrderParam, TableQueryOptions } from './TableQuery';
import { serializeFilters } from '../../components/Module/Table/Filters/FilterInput/utils';

export interface TableRecord extends GeoJSON.Feature {
  id: number;
}

export interface GeoJSONRecordWithAttachmentAndDisplay extends TableRecord {
  _display: object;
  _attachments: number[];
}

export interface GeoJSONCollectionWithAttachmentAndDisplay {
  _count: number;
  type: 'FeatureCollection';
  features: GeoJSONRecordWithAttachmentAndDisplay[];
}

export class TableAPIService {
  private _recordApi: GeojsonApi = services.records;
  private _tableApi: TableapiApi = services.table;

  loadColumns = async (table_name: string) => {
    const resp = await this._tableApi.apiColumnsList(1, 0, {
      query: {
        table_name,
      },
    });

    return resp.data.results;
  };

  loadInfo = async (tableId: string) => {
    const resp = await this._tableApi.apiTablesRead(tableId);

    return resp.data;
  };

  loadRecords = async (
    table_name: string,
    query: TableQueryOptions,
    columns: Column[],
  ) => {
    const additionalQuery = {
      _display: this._buildDisplayParam(columns),
      _attachments: true,
    };

    const { filterFields, page, pageSize, order } = query;

    const serializedQuery = this._serializeQuery(
      columns,
      filterFields,
      page,
      pageSize,
      order,
    );

    // undefined, undefined Этот эндпоинт требует offset и limit пагинацию, поэтому без разницы что передаётся в page и page-size
    const response = await this._recordApi.apiGeojsonList(
      table_name,
      undefined,
      undefined,
      {
        query: { ...serializedQuery, ...additionalQuery },
      },
    );

    return response.data as unknown as GeoJSONCollectionWithAttachmentAndDisplay;
  };

  private _buildDisplayParam = (columns: Column[]) => {
    return columns
      .filter((item) => !!item.references)
      .map((item) => item.column_name)
      .join(',');
  };

  private _serializeQuery = (
    columns: Column[],
    filterValues: FilterValue,
    page: number,
    pageSize: number,
    order?: OrderParam,
  ): Record<string, string> => {
    let result: Record<string, string> = {
      _offset: (page - 1) * pageSize + '',
      _limit: pageSize + '',
    };

    if (columns) {
      const params = serializeFilters(columns, filterValues);

      result = { ...result, ...params };
    }

    if (order) {
      const { direction, field } = order;

      result['_order'] = `${direction === 'descend' ? '-' : ''}${field}`;
    }

    return result;
  };
}
